export default "__VITE_ASSET__D0rt01Z3__"